import { ChooseNextAction } from './choose-next-action.enum';

export const DIALOG_ACTIONS_CONFIG = {
  continuedStay: {
    label: ChooseNextAction.ContinuedStay,
    value: ChooseNextAction.ContinuedStay,
    disabled: false,
  },
  level: {
    label: ChooseNextAction.Level,
    value: ChooseNextAction.Level,
    disabled: false,
  },
  withoutRequest: {
    label: ChooseNextAction.WithoutRequest,
    value: ChooseNextAction.WithoutRequest,
    disabled: false,
  },
}
